// Lưu/đọc/xóa Mattermost bot token trong macOS Keychain qua `security` CLI —
// KHÔNG dùng keytar/@napi-rs-keyring (native dep, dễ vỡ CI trên non-macOS).
// `security` là built-in macOS, gọi qua execFile (không qua shell → an toàn hơn exec).
//
// Service name cố định "avatar-mattermost-bot"; account = botName (vd "avatar").
// Chủ yếu phục vụ reuse token cho bot mặc định @avatar (run-comm-setup-phase.ts +
// comm-connect.ts) — tránh hỏi lại password mỗi lần setup/connect.
import { execFile } from "node:child_process";
import { promisify } from "node:util";

const execFileAsync = promisify(execFile);

export const MATTERMOST_KEYCHAIN_SERVICE = "avatar-mattermost-bot";

// Lưu token cho botName vào Keychain. `-U` = update-if-exists (upsert, không lỗi
// khi entry đã tồn tại). Lỗi execFile (vd không phải macOS) → nuốt, không throw
// ra ngoài vì đây là tiện ích best-effort, không phải nguồn credential chính.
export async function saveBotToken(botName: string, token: string): Promise<void> {
  try {
    await execFileAsync("security", [
      "add-generic-password",
      "-U",
      "-s",
      MATTERMOST_KEYCHAIN_SERVICE,
      "-a",
      botName,
      "-w",
      token,
    ]);
  } catch {
    // Best-effort: không chặn flow chính nếu Keychain ghi lỗi (vd non-macOS, sandbox).
  }
}

// Đọc token đã lưu cho botName. Trả null nếu chưa từng lưu (security exit != 0)
// hoặc gặp lỗi bất kỳ (không phải macOS, Keychain bị khoá, v.v.).
export async function getBotToken(botName: string): Promise<string | null> {
  try {
    const { stdout } = await execFileAsync("security", [
      "find-generic-password",
      "-s",
      MATTERMOST_KEYCHAIN_SERVICE,
      "-a",
      botName,
      "-w",
    ]);
    const token = stdout.trim();
    return token.length > 0 ? token : null;
  } catch {
    return null;
  }
}

// Xóa token đã lưu cho botName. Ignore lỗi nếu không có entry (không cần xử lý gì
// thêm — mục tiêu cuối cùng "không còn token trong Keychain" đã đạt).
export async function deleteBotToken(botName: string): Promise<void> {
  try {
    await execFileAsync("security", [
      "delete-generic-password",
      "-s",
      MATTERMOST_KEYCHAIN_SERVICE,
      "-a",
      botName,
    ]);
  } catch {
    // Ignore — không có entry để xóa cũng là kết quả chấp nhận được.
  }
}
